import React from 'react';
import { useQuery } from '@apollo/client/react';
import { AUTHORS } from 'lib/graphql/queries/user';
import AuthorsSelectBase from './AuthorsSelect';
import { SearchAuthorResult } from '@elevator/ui';

/**
 * AuthorsSelect component with GraphQL query integration.
 * Fetches authors data and renders AuthorsSelectBase component.
 * This is the default export, providing the full-featured component with data fetching.
 */
const AuthorsSelect = (props: AuthorsSelectPropTypes) => {
  const { onChange, value } = props;

  const { data } = useQuery<{
    authors?: SearchAuthorResult[];
  }>(AUTHORS, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'cache-first',
  });

  const authors = (data && data.authors) || [];

  return (
    authors.length > 0 && (
      <AuthorsSelectBase authors={authors} onChange={onChange} value={value} />
    )
  );
};

export interface AuthorsSelectPropTypes {
  onChange: (preferredUsername: string) => void;
  value?: string;
}

export default AuthorsSelect;
